import { render, staticRenderFns } from "./WhatsappMessageList.vue?vue&type=template&id=b235b838"
import script from "./WhatsappMessageList.vue?vue&type=script&lang=js"
export * from "./WhatsappMessageList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessageList.vue?vue&type=style&index=0&id=b235b838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports